export class Country {

    /** ISO 3166-1 alpha-3 country code */
    cca3 : string;
    name : string;

    constructor(pCca3 : string, pName : string) {
        this.cca3 = pCca3;
        this.name = pName;
    }
}

/**
 * Purpose of this function is to select the appropriate name of the country
 * depending on the user locale
 * @param unformattedCountriesList list fom countries.json unformatted
 * @param language the locale of the logged user (FR, EN ES for now)
 */
export function extractCountries(unformattedCountriesList : any[], language : string) : Country[] {
    let countriesToReturn : Country[] = [];
    let countryName : string = "";

    unformattedCountriesList.forEach(c => {
        if (language != 'EN' && c.translations[language]) {
            countryName = c.translations[language].common

        } if (language == 'EN' || countryName == ""){
            countryName = c.name.common;
        }
        
        countriesToReturn.push(new Country(c.cca3, countryName));
    });    
    return countriesToReturn;
}


// WEBPACK FOOTER //
// ./src/app/utils/country.ts